export default __webpack_public_path__ + "static/media/SBLCentral-Logo-Resize.e0a05f13.jpg";